import { Pipe, PipeTransform } from '@angular/core';
import { BaseWooCommerceAddressDetails } from '../../core/interfaces/woo-commerce/woo-commerce.interface';

@Pipe({ name: 'address', pure: true })
export class AddressPipe implements PipeTransform {
  transform(value?: BaseWooCommerceAddressDetails | null): string {
    if (value == null) return '';

    // If label exists (e.g., for pickup locations), use it directly
    if (value.label?.trim()) {
      return value.label.trim();
    }

    const parts: string[] = [];

    const address = value.address_1?.trim();
    const city = value.city?.trim();
    const state = value.state?.trim();
    const postcode =
      value.postcode == null || value.postcode
        ? String(value.postcode).trim()
        : '';

    const country: string = value.country?.trim();

    const stateZip: string =
      state && postcode ? `${state} ${postcode}` : state || postcode || '';

    if (address) parts.push(address);
    if (city) parts.push(city);
    if (stateZip) parts.push(stateZip);
    if (country) parts.push(country);

    return parts.join(', ') || '';
  }
}
